import { render, staticRenderFns } from "./CpcHighPriceMaintain.vue?vue&type=template&id=2fad945c&scoped=true"
import script from "./CpcHighPriceMaintain.vue?vue&type=script&lang=js"
export * from "./CpcHighPriceMaintain.vue?vue&type=script&lang=js"
import style0 from "./CpcHighPriceMaintain.vue?vue&type=style&index=0&id=2fad945c&prod&scoped=true&lang=css"
import style1 from "./CpcHighPriceMaintain.vue?vue&type=style&index=1&id=2fad945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad945c",
  null
  
)

export default component.exports